"use strict";
/* tslint:disable */
/* eslint-disable */
/*
Carbon

Connect external data to LLMs, no matter the source.

The version of the OpenAPI document: 1.0.0


NOTE: This file is auto generated by Konfig (https://konfigthis.com).
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configuration = void 0;
class Configuration {
    constructor(param = {}) {
        var _a;
        if (this.apiKey === undefined) {
            this.apiKey = {};
            if (param.accessToken !== undefined)
                this.apiKey["accessToken"] = param.accessToken;
            if (param.apiKey !== undefined)
                this.apiKey["apiKey"] = param.apiKey;
            if (param.customerId !== undefined)
                this.apiKey["customerId"] = param.customerId;
        }
        this.basePath = param.basePath;
        this.baseOptions = (_a = param.baseOptions) !== null && _a !== void 0 ? _a : {};
        this.userAgent = param.userAgent === undefined ? "Konfig/0.2.48/typescript" : param.userAgent;
        this.formDataCtor = param.formDataCtor;
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    isJsonMime(mime) {
        const jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    }
}
exports.Configuration = Configuration;
